import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <ul aria-labelledby={{@ariaLabelledby}}>
  {{#if this.siteSettings.enable_user_status}}
    <li class="set-user-status">
      <DButton
        @action={{this.setUserStatusClick}}
        class="btn-flat profile-tab-btn"
      >
        {{#if this.currentUser.status}}
          {{emoji this.currentUser.status.emoji}}
          <span class="item-label">
            {{this.currentUser.status.description}}
            {{#if this.currentUser.status.ends_at}}
              {{format-age this.currentUser.status.ends_at}}
            {{/if}}
          </span>
        {{else}}
          {{d-icon "plus-circle"}}
          <span class="item-label">
            {{i18n "user_status.set_custom_status"}}
          </span>
        {{/if}}
      </DButton>
    </li>
  {{/if}}

  <li class="summary">
    <LinkTo @route="user.summary" @model={{this.currentUser}}>
      {{d-icon "user"}}
      <span class="item-label">
        {{i18n "user.summary.title"}}
      </span>
    </LinkTo>
  </li>

  <li class="activity">
    <LinkTo @route="userActivity" @model={{this.currentUser}}>
      {{d-icon "stream"}}
      <span class="item-label">
        {{i18n "user.activity_stream"}}
      </span>
    </LinkTo>
  </li>

  {{#if this.currentUser.can_invite_to_forum}}
    <li class="invites">
      <LinkTo @route="userInvited" @model={{this.currentUser}}>
        {{d-icon "user-plus"}}
        <span class="item-label">
          {{i18n "user.invited.title"}}
        </span>
      </LinkTo>
    </li>
  {{/if}}

  <li class="drafts">
    <LinkTo @route="userActivity.drafts" @model={{this.currentUser}}>
      {{d-icon "user_menu.drafts"}}
      <span class="item-label">
        {{#if this.currentUser.draft_count}}
          {{i18n "drafts.label_with_count" count=this.currentUser.draft_count}}
        {{else}}
          {{i18n "drafts.label"}}
        {{/if}}
      </span>
    </LinkTo>
  </li>

  <li class="preferences">
    <LinkTo @route="preferences" @model={{this.currentUser}}>
      {{d-icon "cog"}}
      <span class="item-label">
        {{i18n "user.preferences.title"}}
      </span>
    </LinkTo>
  </li>

  <li class="do-not-disturb">
    <DButton
      @action={{this.doNotDisturbClick}}
      class="btn-flat profile-tab-btn"
    >
      {{d-icon (if this.isInDoNotDisturb "toggle-on" "toggle-off")}}
      <span class="item-label">
        {{#if this.isInDoNotDisturb}}
          <span>{{i18n "pause_notifications.label"}}</span>
          {{#if this.showDoNotDisturbEndDate}}
            {{format-age this.doNotDisturbDateTime}}
          {{/if}}
        {{else}}
          {{i18n "pause_notifications.label"}}
        {{/if}}
      </span>
    </DButton>
  </li>

  {{#if this.showToggleAnonymousButton}}
    <li
      class={{if
        this.currentUser.is_anonymous
        "disable-anonymous"
        "enable-anonymous"
      }}
    >
      <DButton
        @action={{this.toggleAnonymous}}
        class="btn-flat profile-tab-btn"
      >
        {{#if this.currentUser.is_anonymous}}
          {{d-icon "ban"}}
          <span class="item-label">
            {{i18n "switch_from_anon"}}
          </span>
        {{else}}
          {{d-icon "user-secret"}}
          <span class="item-label">
            {{i18n "switch_to_anon"}}
          </span>
        {{/if}}
      </DButton>
    </li>
  {{/if}}

  {{#each this.extraItems as |item|}}
    <li class={{item.className}}>
      <a href={{item.href}}>
        {{#if item.icon}}
          {{d-icon item.icon}}
        {{/if}}
        <span class="item-label">
          {{item.content}}
        </span>
      </a>
    </li>
  {{/each}}

  <li class="logout">
    <DButton @action={{route-action "logout"}} class="btn-flat profile-tab-btn">
      {{d-icon "sign-out-alt"}}
      <span class="item-label">
        {{i18n "user.log_out"}}
      </span>
    </DButton>
  </li>
</ul>
*/
{
  "id": "KByeUTFW",
  "block": "[[[10,\"ul\"],[15,\"aria-labelledby\",[30,1]],[12],[1,\"\\n\"],[41,[30,0,[\"siteSettings\",\"enable_user_status\"]],[[[1,\"    \"],[10,\"li\"],[14,0,\"set-user-status\"],[12],[1,\"\\n      \"],[8,[39,1],[[24,0,\"btn-flat profile-tab-btn\"]],[[\"@action\"],[[30,0,[\"setUserStatusClick\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"status\"]],[[[1,\"          \"],[1,[28,[35,2],[[30,0,[\"currentUser\",\"status\",\"emoji\"]]],null]],[1,\"\\n          \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n            \"],[1,[30,0,[\"currentUser\",\"status\",\"description\"]]],[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"status\",\"ends_at\"]],[[[1,\"              \"],[1,[28,[35,3],[[30,0,[\"currentUser\",\"status\",\"ends_at\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,4],[\"plus-circle\"],null]],[1,\"\\n          \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"user_status.set_custom_status\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,\"li\"],[14,0,\"summary\"],[12],[1,\"\\n    \"],[8,[39,6],null,[[\"@route\",\"@model\"],[\"user.summary\",[30,0,[\"currentUser\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"user\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"user.summary.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"li\"],[14,0,\"activity\"],[12],[1,\"\\n    \"],[8,[39,6],null,[[\"@route\",\"@model\"],[\"userActivity\",[30,0,[\"currentUser\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"stream\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"user.activity_stream\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"currentUser\",\"can_invite_to_forum\"]],[[[1,\"    \"],[10,\"li\"],[14,0,\"invites\"],[12],[1,\"\\n      \"],[8,[39,6],null,[[\"@route\",\"@model\"],[\"userInvited\",[30,0,[\"currentUser\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,4],[\"user-plus\"],null]],[1,\"\\n        \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"user.invited.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,\"li\"],[14,0,\"drafts\"],[12],[1,\"\\n    \"],[8,[39,6],null,[[\"@route\",\"@model\"],[\"userActivity.drafts\",[30,0,[\"currentUser\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"user_menu.drafts\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"draft_count\"]],[[[1,\"          \"],[1,[28,[35,5],[\"drafts.label_with_count\"],[[\"count\"],[[30,0,[\"currentUser\",\"draft_count\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,5],[\"drafts.label\"],null]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"li\"],[14,0,\"preferences\"],[12],[1,\"\\n    \"],[8,[39,6],null,[[\"@route\",\"@model\"],[\"preferences\",[30,0,[\"currentUser\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"cog\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"user.preferences.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"li\"],[14,0,\"do-not-disturb\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"btn-flat profile-tab-btn\"]],[[\"@action\"],[[30,0,[\"doNotDisturbClick\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[[52,[30,0,[\"isInDoNotDisturb\"]],\"toggle-on\",\"toggle-off\"]],null]],[1,\"\\n      \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n\"],[41,[30,0,[\"isInDoNotDisturb\"]],[[[1,\"          \"],[10,1],[12],[1,[28,[35,5],[\"pause_notifications.label\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"showDoNotDisturbEndDate\"]],[[[1,\"            \"],[1,[28,[35,3],[[30,0,[\"doNotDisturbDateTime\"]]],null]],[1,\"\\n\"]],[]],null]],[]],[[[1,\"          \"],[1,[28,[35,5],[\"pause_notifications.label\"],null]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showToggleAnonymousButton\"]],[[[1,\"    \"],[10,\"li\"],[15,0,[52,[30,0,[\"currentUser\",\"is_anonymous\"]],\"disable-anonymous\",\"enable-anonymous\"]],[12],[1,\"\\n      \"],[8,[39,1],[[24,0,\"btn-flat profile-tab-btn\"]],[[\"@action\"],[[30,0,[\"toggleAnonymous\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"is_anonymous\"]],[[[1,\"          \"],[1,[28,[35,4],[\"ban\"],null]],[1,\"\\n          \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"switch_from_anon\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,4],[\"user-secret\"],null]],[1,\"\\n          \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"switch_to_anon\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"extraItems\"]]],null]],null],null,[[[1,\"    \"],[10,\"li\"],[15,0,[30,2,[\"className\"]]],[12],[1,\"\\n      \"],[10,3],[15,6,[30,2,[\"href\"]]],[12],[1,\"\\n\"],[41,[30,2,[\"icon\"]],[[[1,\"          \"],[1,[28,[35,4],[[30,2,[\"icon\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n          \"],[1,[30,2,[\"content\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[2]],null],[1,\"\\n  \"],[10,\"li\"],[14,0,\"logout\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"btn-flat profile-tab-btn\"]],[[\"@action\"],[[28,[37,9],[\"logout\"],null]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,4],[\"sign-out-alt\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"item-label\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"user.log_out\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@ariaLabelledby\",\"item\"],false,[\"if\",\"d-button\",\"emoji\",\"format-age\",\"d-icon\",\"i18n\",\"link-to\",\"each\",\"-track-array\",\"route-action\"]]",
  "moduleName": "discourse/components/user-menu/profile-tab-content.hbs",
  "isStrictMode": false
});